module.exports = __webpack_public_path__ + "static/img/refause.1fbd9e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/refause.png
// module id = 672
// module chunks = 1